import { getEditorState } from '~/shell/Store';

export const duplicateTab = async (
  sourceTab: any,
  position: number,
  sequenceId: number | string,
  addSubItem: (config: any) => void
) => {
  const tempId = `temp-${Date.now()}`;

  addSubItem({
    sequenceId: sequenceId,
    data: {
      type: 'TAB',
      title: sourceTab.title || '',
      value: sourceTab.title || '',
      position: position,
      parent_id: null
    },
    newItem: {
      id: tempId,
      __typename: 'Tab',
      typename: 'Tab',
      position: position,
      title: sourceTab.title,
      subtitle: sourceTab.subtitle,
      body: sourceTab.body,
      icon: sourceTab.icon,
      pictures: Array.isArray(sourceTab.pictures)
        ? sourceTab.pictures.map((p: any) => ({ ...p }))
        : []
    },
    onCreated: async (realId: string | number) => {
      const state = getEditorState();
      const api = (state as any).apiService;

      try {
        if (sourceTab.subtitle) {
          state.updateSequence(realId, 'subtitle', sourceTab.subtitle);
        }
        if (sourceTab.body) {
          state.updateSequence(realId, 'body', sourceTab.body);
        }
        if (sourceTab.icon) {
          state.updateSequence(realId, 'icon', sourceTab.icon);
        }

        if (api) {
          if (
            Array.isArray(sourceTab.pictures) &&
            sourceTab.pictures.length > 0
          ) {
            const validPictureIds = sourceTab.pictures
              .map((p: any) => p.id)
              .filter(Boolean);
            if (validPictureIds.length > 0) {
              await api.updateSubItem(realId, 'picture_ids', validPictureIds);
            }
          }
        }
      } catch (e) {
        console.error('Duplicate tab persistence failed', e);
      }
    }
  });
};
